import type { RootState } from '../store';
import type { DecryptedItem } from '../common/types/items';
import { Transfer } from '../common/types/transfer';

const getTransfers = (state: RootState): DecryptedItem<Transfer>[] => state.transfers.transfers;

const getCurrentTransfer = (state: RootState): DecryptedItem<Transfer> | null => state.transfers.currentTransfer;

const getStatus = (state: RootState) => state.transfers.status;

const transferSelector = {
  getTransfers,
  getCurrentTransfer,
  getStatus,
};

export default transferSelector;
